import Phaser from 'phaser';

import TimeLimit from './_timelimit';
import Score from './_score';


export default class GameUI{

    constructor(){
        this.scene =  window.GAME_REF.scene;
        GAME_REF.obj.ui = this;
        
        this._init();
    }


    render(){
        this.time.render();
        this.score.render();
    }


    _init(){
        this.time = new TimeLimit();
        this.time.emitter.on(this.time.EVENT_COMPLETE, ()=>{
            GAME_REF.obj.manager.gameEnd();
        });

        this.score = new Score();
    }
}